import React from "react";
import ReactDOMServer from "react-dom/server";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import NewTr from "../common/table/newTr";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import ButtonTable from "../common/table/buttonTable";
import Button from "../common/button/button";
import Form from "./faturaForm";
import FormatUtils from "../common/formatUtils/FormatUtils";

import FormMultiplo from "./faturaFormMultiplo";
import Select from "../common/form/select";

import { DisplayPDF } from "../displayPDF/displayPDF";
import AlertIcon from "../common/alertIcon/alertIcon";

// import { htmlToPdf } from "../htmlToPdf/htmlToPdf";
import TabelaFaturaAdmPDF from "../htmlToPdf/TabelaFaturaAdmPDF";
import {
    salvar,
    excluir,
    initForm,
    getListaFaturasAdm,
    buscarPdf,
    setFiltro,
    setModoTela,
    setAguardando,
    gerarRelatorio,
    gerarXlsx,
    salvarMultiplos,
    setAlertaVerificado,
    alterarStatusAlerta,
    buscarPdfFaturaAdicional,
    getListaGraficoGeracaoSaldo,
    getListaProdutoTipo,
    getListaClientesUcsFiltradosSelect,
} from "./faturaActions";

import { setArquivoPDF } from "../displayPDF/displayPDFActions";

import { reprocessar, reprocessarTodas, executarManutencao, reprocessarIsenta } from "./faturaItem/faturaItemActions";
import { getListaGrupoFaturamento, getListaUsuarioAdministrador, getListaUsuarioAdministradorVinculadoCliente } from "../cliente/clienteActions";
import { Loading } from "../common/loading/loading";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import { setError, setSuccess } from "../common/toast/toast";
import TableInCell from "../common/table/tableInCell";
import DateFormat from "../common/dateFormat/DateFormat";
import { CabecalhoTabelaFaturaEnergia } from "./components/CabecalhoTabelaFaturaEnergia";
import { RodapeTotaisFaturaEnergia } from "./components/RodapeTotaisFaturaEnergia";
import { getMensagensAlerta, getMensagensErro, ModalAlertasErrosFatura } from "./components/ModalAlertasErrosFatura";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";
import { ModalTabelaSaldosAgenciaVirtual } from "./components/ModalTabelaSaldosAgenciaVirtual";
import { FiltrosFaturasAdmEnergia } from "./components/FiltrosFaturasAdmEnergia";
import { BotaoGerarRelatorio } from "../common/button/BotaoGerarRelatorio";
import { ArrowOrEqualIcon } from "../common/arrowOrEqualIcon/ArrowOrEqualIcon";
import { validarTarifaMediaLiquida } from "../core/validarTarifaMediaLiquida";
import { DangerIcon } from "../common/dangerIcon/DangerIcon";
import { ModalBalancoEnergetico } from "../geracaoLeitura/components/ModalBalancoEnergetico";
import { useState } from "react";
import { useEffect } from "react";
import { ModalGraficoSaldos } from "./components/ModalGraficoSaldos";
import { ModalSelecaoPdfFatura } from "./components/ModalSelecaoPdfFatura";
import { SolCasaFatura } from "./components/SolCasaFatura";

const INITIAL_STATE = {
    statusTodasCores: true,
    statusCorBranca: true,
    statusCorVerde: true,
    statusCorAzul: true,
    statusCorAmarela: true,
    statusCorVermelha: true,
    statusImportacaoSolarVerde: false,
    statusImportacaoSolarVermelha: false,
    apenasDownloadAtrasado: false,
    apenasUnidadesEmImplantacao: false,
    apenasFaturasItemSemTipo: false,
    apenasMercadoLivreSemDespesas: false,
    apenasFaturasRefaturadas: false,
    apenasAlertas: false,
    apenasAlertasVerificados: false,
    idUsuarioResponsavel: null,
    exibirErros: false,
    modalAlertaOportunidade: false,
    exibirModalSelecaoFatura: false,
    exibirGraficoSaldoGeracao: false,
    itemPdfSelecionado: null,
    conteudoModalAlertaErros: null,
    saldosAgenciaVirtual: null,
    exibirModalGestorConcessionaria: false,
    exibirModalBalancoEnergetico: false,
    itemSelecionado: null,
};

const INITIAL_TOTAIS = {
    totalValorImportado: 0,
    totalValorFatura: 0,
    totalenergia: 0,
    totalEnergiaPonta: 0,
    totalEnergiaForaPonta: 0,
    totalEnergiaReservado: 0,
    totalDemanda: 0,
    totalDemandaReservado: 0,
    totalDemandaPonta: 0,
    totalDemandaGeracao: 0,
    totalValorDemanda: 0,
    totalValorDemandaReservado: 0,
    totalValorDemandaPonta: 0,
    totalValorDemandaGeracao: 0,
    totalEnergiaReativo: 0,
    totalEnergiaExcedente: 0,
    totalProducaoSolar: 0,
    totalGastoReativo: 0,
    totalSaldo: 0,
    totalDemandaContratadaFpContrato: 0,
    totalDemandaContratadaPContrato: 0,
    totalDemandaContratadaFpFatura: 0,
    totalDemandaContratadaPFatura: 0,
    totalCustoEnergiaACL: 0,
    totalCustoGestaoACL: 0,
    totalContribuicaoAssociativaCCEE: 0,
    totalValorPisPasep: 0,
    totalValorCofins: 0,
    totalValorIcms: 0,
    quantidadeUnidadesFiltradas: 0,
    qtdCorBranca: 0,
    qtdCorVerde: 0,
    qtdCorAzul: 0,
    qtdCorAmarela: 0,
    qtdCorVermelha: 0,
    qtdCorVermelhaAlertas: 0,
    qtdImportacaoSolarVerde: 0,
    qtdImportacaoSolarVermelha: 0,
    qtdUnidadesDownloadAtrasado: 0,
    qtdUnidadesEmImplantacao: 0,
    qtdFaturasItemSemTipo: 0,
    qtdMercadoLivreSemDespesas: 0,
    qtdFaturasRefaturadas: 0,
};

const CORES = {
    BRANCA: { backgroundColorTr: "rgb(255, 255, 255)", backgroundColorTd: "rgb(245, 245, 245)" },
    //se estiver paga retorna verde
    VERDE: { backgroundColorTr: "rgb(221, 255, 221)", backgroundColorTd: "rgb(68, 255, 170)" },
    AZUL: {
        backgroundColorTr: "rgb(243 255 255)",
        backgroundColorTd: "rgb(197 255 255)",
    },
    AMARELA: {
        backgroundColorTr: "rgb(255 255 212)",
        backgroundColorTd: "rgb(255 239 113)",
    },
    VERMELHA: {
        backgroundColorTr: "rgb(251 202 202)",
        backgroundColorTd: "rgb(255 101 105)",
    },
    VERMELHA_ALERTA: {
        backgroundColorTr: "#FC5959",
        backgroundColorTd: "#C40D11",
    },
};

function FaturaEnergiaAdm(props) {
    if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente) return <div style={{ color: "red" }}>Acesso Negado.</div>;

    const usuarioAcessoEditar = props.usuarioLogado && (props.usuarioLogado.acesso_fatura_editar || props.usuarioLogado.acesso_fatura_editar_fechado);

    const [faturasFiltradas, setFaturasFiltradas] = useState([]);
    const [state, setState] = useState(INITIAL_STATE);
    const [totais, setTotais] = useState(INITIAL_TOTAIS);
    const [alertaAlterando, setAlertaAlterando] = useState(null);

    function handleResetStates() {
        setFaturasFiltradas([]);
        setTotais(INITIAL_TOTAIS);
    }

    useEffect(() => {
        props.getListaClientesUcsFiltradosSelect();
        props.getListaProdutoTipo();
        props.getListaGrupoFaturamento();
        props.getListaUsuarioAdministrador();
        props.getListaUsuarioAdministradorVinculadoCliente();
        // só chama se filtro estiver vazio
        const filtroVazio =
            !props.filtro.id_cliente && !props.filtro.ano && !props.filtro.mes && (!props.filtro.unidades_consumidoras || !props.filtro.unidades_consumidoras.length);
        if (filtroVazio) {
            props.getListaFaturasAdm();
        }
    }, []);

    useEffect(() => {
        handleResetStates();
        props.getListaFaturasAdm();
    }, [props.filtro]);

    useEffect(() => {
        if (!props.usuarioLogado) return;
        const listaAtualizada = [];
        const totaisAtualizados = { ...INITIAL_TOTAIS };
        for (const item of props.lista) {
            if (!itemCorrespondeAoFiltro(item)) {
                // console.log("uc" + item.id_unidade_consumidora + " IGNORADA");
                continue;
            }
            listaAtualizada.push(item);
            contabilizarTotais({ item, totais: totaisAtualizados });
            // console.log(item.id_unidade_consumidora + " INCLUIDO");
        }

        setFaturasFiltradas(listaAtualizada);
        setTotais(totaisAtualizados);
    }, [
        props.lista,
        props.usuarioLogado,
        props.filtro,
        state.statusCorAzul,
        state.statusCorAmarela,
        state.statusCorVermelha,
        state.statusCorVerde,
        state.statusCorBranca,
        state.apenasUnidadesEmImplantacao,
        state.apenasDownloadAtrasado,
        state.apenasFaturasItemSemTipo,
        state.apenasMercadoLivreSemDespesas,
        state.apenasFaturasRefaturadas,
        state.apenasAlertas,
        state.apenasAlertasVerificados,
        state.idUsuarioResponsavel,
        state.statusImportacaoSolarVerde,
        state.statusImportacaoSolarVermelha,
    ]);

    return (
        <div>
            <DisplayPDF closePdf={props.setArquivoPDF} pdfBase64={props.pdf} nomePdf={props.nomePdf} orientation={props.orientation} zoomParametro={1.5} />
            {props.aguardando ? <Loading /> : null}

            <ModalAlertasErrosFatura
                showModal={state.exibirErros}
                idFatura={state.idFaturaModalAlertas}
                conteudoErros={state.conteudoModalAlertaErros}
                lista={props.lista}
                listaUsuarioAdministrador={props.listaUsuarioAdministrador}
                alertaAlterando={alertaAlterando}
                somenteOportunidade={state.modalAlertaOportunidade}
                onClose={fecharModalAlertaErros}
                onAlterarStatusAlerta={alterarStatusAlertaItem}
                onMarcarTodos={props.setAlertaVerificado}
                onReprocessarIsenta={props.reprocessarIsenta}
            />

            <ModalGraficoSaldos
                visible={state.exibirGraficoSaldoGeracao && !props.pdf && !props.aguardando}
                handleClose={() => setState({ ...state, exibirGraficoSaldoGeracao: false, itemSelecionado: null })}
                listaGraficoGeracaoSaldo={props.listaGraficoGeracaoSaldo}
                gerarRelatorio={props.gerarRelatorio}
                state={state}
            />

            <ModalTabelaSaldosAgenciaVirtual
                visible={state.saldosAgenciaVirtual && !props.pdf}
                handleClose={() => setState({ ...state, saldosAgenciaVirtual: null })}
                saldosAgenciaVirtual={state.saldosAgenciaVirtual}
            />

            <ModalSelecaoPdfFatura
                visible={state.exibirModalSelecaoFatura && !props.pdf}
                handleClose={() => setState({ ...state, exibirModalSelecaoFatura: false, itemPdfSelecionado: null })}
                buscarPdf={props.buscarPdf}
                state={state}
                usuarioLogado={props.usuarioLogado}
                setArquivoPDF={props.setArquivoPDF}
                buscarPdfFaturaAdicional={props.buscarPdfFaturaAdicional}
            />

            <ModalBalancoEnergetico
                itemSelecionado={state.itemSelecionado}
                visible={state.exibirModalBalancoEnergetico && state.itemSelecionado}
                handleClose={() => setState({ ...state, exibirModalBalancoEnergetico: false, itemSelecionado: null })}
            />
            <Content>
                <div style={props.pdf ? { display: "none" } : {}}>
                    {props.modoTela === "visualizacao" ? <Form visualizar /> : null}
                    {props.modoTela === "cadastro" ? <Form onSubmit={props.salvar} /> : null}
                    {props.modoTela === "cadastroMultiplo" ? <FormMultiplo onSubmit={props.salvarMultiplos} /> : null}
                    {props.modoTela === "exclusao" ? <Form excluir onSubmit={props.excluir} /> : null}
                    {props.modoTela === "lista" ? lista() : null}
                </div>
            </Content>
        </div>
    );

    function lista() {
        let statusAtivos = [];
        if (state.statusCorBranca) statusAtivos.push("Faturas não importadas");
        if (state.statusCorVerde) statusAtivos.push("Faturas validadas e sem erros");
        if (state.statusCorAzul) statusAtivos.push("Faturas isentas");
        if (state.statusCorAmarela) statusAtivos.push("Faturas corrigidas");
        if (state.statusCorVermelha) statusAtivos.push("Faturas com necessidade de correção");
        if (
            state.statusCorBranca &&
            state.statusCorVerde &&
            state.statusCorAzul &&
            state.statusCorAmarela &&
            state.statusCorVermelha &&
            !state.statusImportacaoSolarVerde &&
            !state.statusImportacaoSolarVermelha
        )
            statusAtivos = "Todas as faturas";

        const cabecalho = <CabecalhoTabelaFaturaEnergia />;
        const rodape = <RodapeTotaisFaturaEnergia totais={totais} />;
        const listaUcsFiltradas = listarUCsFiltradas();
        return (
            <ContentCard>
                <ModalGestorConcessonaria
                    visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_energia}
                    itemSelecionado={state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                    <ContentCardHeader>
                        <Row style={{ paddingRight: 5 }}>
                            <Grid cols="12 4 4 2">
                                <Button
                                    text="Adicionar"
                                    type={"success"}
                                    icon={"fa fa-plus"}
                                    style={{ marginTop: 28 }}
                                    disabled={!usuarioAcessoEditar || props.aguardando}
                                    event={() => {
                                        props.setModoTela("cadastro", {});
                                        props.initForm({});
                                    }}
                                />
                            </Grid>
                            <Grid cols="12 4 4 2">
                                <Button
                                    text="Adicionar Múltiplos"
                                    type={"success"}
                                    icon={"fa fa-plus-circle"}
                                    style={{ marginTop: 28 }}
                                    disabled={!usuarioAcessoEditar || props.aguardando}
                                    event={() => {
                                        props.setModoTela("cadastroMultiplo", {});
                                        props.initForm({});
                                    }}
                                />
                            </Grid>
                            {props.usuarioLogado &&
                            !props.usuarioLogado.acesso_cliente &&
                            props.usuarioLogado.acesso_fatura_reprocessar &&
                            (props.usuarioLogado.usuario_implantacao || [1, 2].includes(props.usuarioLogado.id)) /*INFINITUM e marthielo*/ ? (
                                <Grid cols="12 4 4 2">
                                    <Button
                                        text="Reprocessar"
                                        type={"success"}
                                        icon={"fa fa-sync"}
                                        style={{ marginTop: 28 }}
                                        disabled={!props.usuarioLogado.acesso_fatura_reprocessar || props.aguardando}
                                        event={() => {
                                            props.reprocessarTodas(faturasFiltradas);
                                        }}
                                    />
                                </Grid>
                            ) : null}

                            {props.usuarioLogado && props.usuarioLogado.id == 1 /*INFINITUM*/ ? (
                                <>
                                    <Grid
                                        cols="12 12 12 6"
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            justifyContent: "center",
                                            paddingTop: window.innerWidth < 992 ? 10 : null,
                                        }}
                                    >
                                        <Select
                                            readOnly={props.aguardando}
                                            name="id_manutencao_produto_tipo"
                                            gridMarginBlock={0}
                                            options={props.listaProdutoTipo.filter((item) => ![21, 47, 48, 49].includes(item.id))} //oculta os que não vem da fatura
                                            label="Manutenção"
                                            cols="12 8 8 8"
                                            placeholder="Selecione o tipo"
                                            value={props.filtro.id_manutencao_produto_tipo}
                                            onChange={(value) => {
                                                props.setFiltro({ ...props.filtro, id_manutencao_produto_tipo: value });
                                            }}
                                        />
                                        <Grid
                                            cols="12 4 4 4"
                                            style={{
                                                padding: window.innerWidth < 992 ? null : "0px 0px 0px 10px",
                                            }}
                                        >
                                            <Button
                                                disabled={props.aguardando}
                                                text="Executar Manutenção"
                                                type={"success"}
                                                style={{ marginTop: window.innerWidth < 992 ? null : 28 }}
                                                event={() => {
                                                    props.executarManutencao(faturasFiltradas, props.filtro.id_manutencao_produto_tipo);
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                            ) : null}
                        </Row>
                    </ContentCardHeader>
                ) : null}
                <FiltrosFaturasAdmEnergia
                    listaUnidadeConsumidora={listaUcsFiltradas}
                    listaUsuarioAdministrador={props.listaUsuarioAdministradorVinculado}
                    setState={(novoFiltro) => setState(novoFiltro)}
                    filtroState={{ ...state }}
                    statusAtivos={statusAtivos}
                    quantidadesFiltro={{ ...totais }}
                    buttons={[<BotaoGerarRelatorio aguardando={props.aguardando} gerarPdf={handleGerarPdf} gerarXlsx={handleGerarXlsx} />]}
                />
                <ContentCardBody>
                    <Table>
                        <THead>{cabecalho}</THead>
                        {props.aguardando ? null : (
                            <TBody>
                                {faturasFiltradas.map((item, indice) => buildRow({ item, indice, getOnlyComponent: true }))}
                                {rodape}
                            </TBody>
                        )}
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );

        function handleGerarPdf() {
            if (!props.filtro.unidades_consumidoras.length && !props.filtro.id_cliente && !props.filtro.id_concessionaria && faturasFiltradas.length > 100) {
                return setError("Selecione um cliente ou alguma unidade consumidora para gerar o relatório");
            }
            const linhas = montarLinhas(faturasFiltradas);
            gerarRelatorio({
                statusAtivos,
                cabecalho,
                rodape,
                linhas,
            });
        }
    }

    function alertasRegularesRevisados(item) {
        const lista = item.alertas || [];
        if (!lista.length) return !!item.alerta_verificado;
        return lista.every((alerta) => alerta.verificado === true);
    }

    function itemCorrespondeAoFiltro(item) {
        const filtroGeracaoSolar =
            !props.filtro.geracao_solar ||
            (props.filtro.geracao_solar === "GERADORAS" && !item.unidade_remota && item.unidade_geradora) ||
            (props.filtro.geracao_solar === "REMOTAS" && item.unidade_remota && !item.unidade_geradora) ||
            (props.filtro.geracao_solar === "SEM GERAÇÃO" && !item.unidade_remota && !item.unidade_geradora) ||
            (props.filtro.geracao_solar === "GERADORAS E REMOTAS" && (item.unidade_remota || item.unidade_geradora));

        const azuis = item.cor === "AZUL" && state.statusCorAzul;
        const amarelos = item.cor === "AMARELA" && state.statusCorAmarela;
        const vermelhos = item.cor === "VERMELHA" && state.statusCorVermelha;
        const verdes = item.cor === "VERDE" && state.statusCorVerde;
        const brancos = item.cor === "BRANCA" && state.statusCorBranca;
        const filtroPorCores = brancos || verdes || azuis || amarelos || vermelhos;

        const filtroImportacaoSolar = filtrarImportacaoSolar(item);

        const mesmoGrupoFaturamento = !props.filtro.id_grupo_faturamento || item.id_grupo_faturamento == props.filtro.id_grupo_faturamento;

        const filtroUnidadesEmImplantacao = !state.apenasUnidadesEmImplantacao || item.id_usuario_implantacao;
        const downloadAtrasado = !state.apenasDownloadAtrasado || item.mensagem_download_atrasado;
        const filtroFaturasItemSemTipo = !state.apenasFaturasItemSemTipo || item.possui_itens_sem_tipo;

        const filtroApenasMercadoLivreSemDespasas =
            !state.apenasMercadoLivreSemDespesas ||
            (item.id &&
                item.id_tipo_mercado == 2 &&
                (!parseFloat(item.custo_energia_acl) || !parseFloat(item.custo_gestao_acl) || !parseFloat(item.contribuicao_associativa_ccee)));

        const filtroApenasRefaturadas = !state.apenasFaturasRefaturadas || item.refaturada;

        const filtroConcessionaria = !props.filtro.id_concessionaria || props.filtro.id_concessionaria == item.id_concessionaria;

        const filtroApenasAlertas =
            !state.apenasAlertas ||
            (((item.alertas.length && !item.fatura_isenta) ||
                (item.alertas.length > 1 && item.fatura_isenta) ||
                !validarTarifaMediaLiquida(item.tarifa_media_liquida) ||
                (!item.unidade_geradora && !item.unidade_remota && item.saldo_geracao > 0)) &&
                !alertasRegularesRevisados(item) &&
                item.importacao_validada);

        const filtroApenasAlertasVerificados = !state.apenasAlertasVerificados || alertasRegularesRevisados(item);
        const filtroUsuarioResponsavel = !state.idUsuarioResponsavel || state.idUsuarioResponsavel == item.id_usuario_responsavel_cliente;

        // Faturas com data de Desligamento não exibe a UC nas competências posteriores ao mês do desligamento
        const dataDesligamento = item.data_desligamento ? String(item.data_desligamento).substring(0, 10) : null;
        const competenciaDesligamento = dataDesligamento ? parseInt(dataDesligamento.substring(0, 4) + dataDesligamento.substring(5, 7)) : null;
        const competenciaAtual = item.competencia ? parseInt(item.competencia) : parseInt(`${props.filtro.ano}${String(props.filtro.mes).padStart(2, "0")}`);
        const filtroDataDesligamento = !competenciaDesligamento || competenciaAtual <= competenciaDesligamento;

        //se o item não faz parde do que foi filtrado, ignora ele
        return (
            mesmoGrupoFaturamento &&
            filtroPorCores &&
            filtroImportacaoSolar &&
            filtroUnidadesEmImplantacao &&
            filtroFaturasItemSemTipo &&
            filtroGeracaoSolar &&
            filtroApenasMercadoLivreSemDespasas &&
            filtroApenasRefaturadas &&
            filtroConcessionaria &&
            filtroApenasAlertas &&
            filtroApenasAlertasVerificados &&
            filtroUsuarioResponsavel &&
            downloadAtrasado &&
            filtroDataDesligamento
        );
    }

    function definirCores(item) {
        let backgroundColorTd = CORES[item.cor] ? CORES[item.cor].backgroundColorTd : "#3f3f3f";
        let backgroundColorTr = CORES[item.cor] ? CORES[item.cor].backgroundColorTr : "#585858";

        //forçar status vermelho quando tarifa média liquida for inválida ou tiver alertas, desde que o alerta não esteja verificado
        //as isentas continua mostrando como azul, apesar de ter um alerta
        if (
            (!validarTarifaMediaLiquida(item.tarifa_media_liquida) ||
                (item.alertas.length && !item.fatura_isenta) ||
                (item.alertas.length > 1 && item.fatura_isenta) ||
                (!item.unidade_geradora && !item.unidade_remota && item.saldo_geracao > 0)) &&
            !alertasRegularesRevisados(item) &&
            item.importacao_validada
        ) {
            backgroundColorTd = CORES["VERMELHA_ALERTA"].backgroundColorTd;
            backgroundColorTr = CORES["VERMELHA_ALERTA"].backgroundColorTr;
        }

        return { backgroundColorTd, backgroundColorTr };
    }

    function contabilizarTotais({ item, totais }) {
        totais.quantidadeUnidadesFiltradas++;

        totais.totalValorImportado += parseFloat(item.total > 0 ? item.total : 0);
        totais.totalValorFatura += parseFloat(item.valor_fatura > 0 ? item.valor_fatura : 0);
        totais.totalenergia += parseFloat(item.energia || 0);
        totais.totalEnergiaPonta += parseFloat(item.energia_ponta || 0);
        totais.totalEnergiaForaPonta += parseFloat(item.energia_fora_ponta || 0);
        totais.totalEnergiaReservado += parseFloat(item.energia_reservado || 0);
        totais.totalDemanda += parseFloat(item.demanda || 0);
        totais.totalDemandaReservado += parseFloat(item.demanda_reservado || 0);
        totais.totalDemandaPonta += parseFloat(item.demanda_ponta || 0);
        totais.totalDemandaGeracao += parseFloat(item.demanda_geracao || 0);
        totais.totalValorDemanda += parseFloat(item.valor_demanda || 0);
        totais.totalValorDemandaReservado += parseFloat(item.valor_demanda_reservado || 0);
        totais.totalValorDemandaPonta += parseFloat(item.valor_demanda_ponta || 0);
        totais.totalValorDemandaGeracao += parseFloat(item.valor_demanda_geracao || 0);
        totais.totalEnergiaReativo += parseFloat(item.energia_reativo || 0);
        totais.totalEnergiaExcedente += parseFloat(item.energia_excedente || 0);
        totais.totalProducaoSolar += parseFloat(item.quantidade_geracao || 0);
        totais.totalGastoReativo += parseFloat(item.gasto_reativo || 0);
        totais.totalSaldo += parseFloat(item.saldo_geracao || 0);

        totais.totalDemandaContratadaFpContrato += parseFloat(item.contrato_demanda_fora_ponta || 0);
        totais.totalDemandaContratadaPContrato += parseFloat(item.contrato_demanda_ponta || 0);
        totais.totalDemandaContratadaFpFatura += parseFloat(item.demanda_contratada_fora_ponta || 0);
        totais.totalDemandaContratadaPFatura += parseFloat(item.demanda_contratada_ponta || 0);

        totais.totalCustoEnergiaACL += parseFloat(item.custo_energia_acl || 0);
        totais.totalCustoGestaoACL += parseFloat(item.custo_gestao_acl || 0);
        totais.totalContribuicaoAssociativaCCEE += parseFloat(item.contribuicao_associativa_ccee || 0);

        totais.totalValorPisPasep += parseFloat(item.valor_pis_pasep || 0);
        totais.totalValorCofins += parseFloat(item.valor_cofins || 0);
        totais.totalValorIcms += parseFloat(item.valor_icms || 0);

        if (item.mensagem_download_atrasado) {
            totais.qtdUnidadesDownloadAtrasado++;
        }
        if (
            item.id &&
            item.id_tipo_mercado == 2 &&
            (!parseFloat(item.custo_energia_acl) || !parseFloat(item.custo_gestao_acl) || !parseFloat(item.contribuicao_associativa_ccee))
        ) {
            totais.qtdMercadoLivreSemDespesas++;
        }

        switch (item.cor) {
            case "AZUL":
                totais.qtdCorAzul++;
                break;
            case "AMARELA":
                totais.qtdCorAmarela++;
                break;
            case "VERDE":
                totais.qtdCorVerde++;
                break;
            case "VERMELHA":
                totais.qtdCorVermelha++;
                break;
            case "BRANCA":
                totais.qtdCorBranca++;
                break;
            default:
                break;
        }

        //forçar status vermelho quando tarifa média liquida for inválida ou tiver alertas, desde que o alerta não esteja verificado
        //as isentas continua mostrando como azul, apesar de ter um alerta
        if (
            (!validarTarifaMediaLiquida(item.tarifa_media_liquida) ||
                (item.alertas.length && !item.fatura_isenta) ||
                (item.alertas.length > 1 && item.fatura_isenta) ||
                (!item.unidade_geradora && !item.unidade_remota && item.saldo_geracao > 0)) &&
            !alertasRegularesRevisados(item) &&
            item.importacao_validada
        ) {
            totais.qtdCorVermelhaAlertas++;
        }

        if (item.id_usuario_implantacao) totais.qtdUnidadesEmImplantacao++;
        if (item.possui_itens_sem_tipo) totais.qtdFaturasItemSemTipo++;
        if (item.refaturada) totais.qtdFaturasRefaturadas++;
        if (item.unidade_geradora) {
            if (parseFloat(item.quantidade_geracao || 0) <= 0) {
                totais.qtdImportacaoSolarVermelha++;
            } else {
                totais.qtdImportacaoSolarVerde++;
            }
        }
    }

    function buildRow({ item, indice = 0, getOnlyComponent = false }) {
        const botoes = montarBotoes(item);
        const { backgroundColorTd, backgroundColorTr } = definirCores(item);

        const existeAlertaAliquotaPisPasep = !!item.alertas.find((al) => al.mensagem === "Verifique a alíquota do PIS/PASEP");
        const existeAlertaValorPisPasep = !!item.alertas.find((al) => al.mensagem === "Verifique o valor do PIS/PASEP");
        const existeAlertaAliquotaCofins = !!item.alertas.find((al) => al.mensagem === "Verifique a alíquota do COFINS");
        const existeAlertaValorCofins = !!item.alertas.find((al) => al.mensagem === "Verifique o valor do COFINS");
        const existeAlertaAliquotaIcms = !!(item.erros_importacao || []).find((er) => er.mensagem === "Alíquota de ICMS inválida");
        const existeAlertaValorIcms = !!item.alertas.find((al) => al.mensagem === "Verifique o valor do ICMS");
        const tarifaReservadoMaiorIgualForaPonta = !!item.alertas.find((al) => al.mensagem === "A Tarifa Reservada é maior ou igual à Tarifa Fora Ponta");

        //se for rge mostra os os 3 valores (ponta,fora ponta, reservado)
        const tarifaPorHorario =
            parseFloat(item.tarifa_energia_ponta) >= 0 || parseFloat(item.tarifa_energia_fora_ponta) >= 0 || parseFloat(item.tarifa_energia_horario_reservado) >= 0;

        const estiloBordaVermelha = { border: "3px solid #000", backgroundColor: "#ff3f6b", color: "#FFF", padding: "7px 15px", margin: 1 };
        const tarifaSelecionada = tarifaPorHorario
            ? [
                  {
                      cabecalho: <div title="Tarifa Energia Ponta">T.P</div>,
                      valor: parseFloat(item.tarifa_energia_ponta) >= 0 ? adicionarPontosMilhar(item.tarifa_energia_ponta, 4) : " - ",
                  },
                  {
                      cabecalho: <div title="Tarifa Energia Fora Ponta">T.FP</div>,
                      valor: (
                          <div
                              style={tarifaReservadoMaiorIgualForaPonta ? estiloBordaVermelha : {}}
                              title={tarifaReservadoMaiorIgualForaPonta ? "A tarifa Fora Ponta é menor ou igual à tarifa Reservado" : ""}
                          >
                              {parseFloat(item.tarifa_energia_fora_ponta) >= 0 ? adicionarPontosMilhar(item.tarifa_energia_fora_ponta, 4) : " - "}
                          </div>
                      ),
                  },
                  {
                      cabecalho: <div title="Tarifa Energia Horário Reservado">T.R</div>,
                      valor: (
                          <div
                              style={tarifaReservadoMaiorIgualForaPonta ? estiloBordaVermelha : {}}
                              title={tarifaReservadoMaiorIgualForaPonta ? "A tarifa Fora Ponta é menor ou igual à tarifa Reservado" : ""}
                          >
                              {parseFloat(item.tarifa_energia_horario_reservado) >= 0 ? adicionarPontosMilhar(item.tarifa_energia_horario_reservado, 4) : " - "}
                          </div>
                      ),
                  },
              ]
            : [{ cabecalho: <div title="Tarifa">T</div>, valor: adicionarPontosMilhar(item.tarifa_economia || 0, 4) }];

        const tarifa = (
            <TableInCell
                lista={[
                    ...tarifaSelecionada,
                    {
                        cabecalho: <div title="Tarifa Média Líquida">T.ML</div>,
                        valor: parseFloat(item.tarifa_media_liquida) >= 0 ? adicionarPontosMilhar(item.tarifa_media_liquida, 4) : " - ",
                    },
                    {
                        cabecalho: <div title="Tarifa Média Bruta">T.MB</div>,
                        valor: parseFloat(item.tarifa_media_bruta) >= 0 ? adicionarPontosMilhar(item.tarifa_media_bruta, 4) : " - ",
                    },
                ]}
            />
        );

        const { msgErroImportacaoHtml, msgErroImportacaoText } = getMensagensErro(item);
        const alertasRevisados = alertasRegularesRevisados(item);
        const oportunidades = item.alertas_oportunidade || [];
        const oportunidadesRevisadas = oportunidades.length > 0 && oportunidades.every((alerta) => alerta.verificado === true);
        const { msgAlertaImportacaoText } = getMensagensAlerta({
            item,
            listaUsuarioAdministrador: props.listaUsuarioAdministrador,
            alertaAlterando,
            onAlterarStatusAlerta: alterarStatusAlertaItem,
            onMarcarTodos: props.setAlertaVerificado,
            onReprocessarIsenta: props.reprocessarIsenta,
            onClose: fecharModalAlertaErros,
        });

        const alertaDemandaFaturadaMaior5pc = getObjetoAlertaDemanda(item);
        const tarifaMediaLiquidaInvalida = !validarTarifaMediaLiquida(item.tarifa_media_liquida);
        const objSaldo = item.saldos_agencia_virtual || {};
        const saldoNormalAgenciaVirtual = objSaldo.saldo_normal || 0;
        const saldoPontaAgenciaVirtual = objSaldo.saldo_ponta || 0;
        const saldoForaPontaAgenciaVirtual = objSaldo.saldo_fora_ponta || 0;
        const somaSaldoPontaForaPonta = saldoPontaAgenciaVirtual + saldoForaPontaAgenciaVirtual;

        const saldoFaturaDiferenteAgenciaVirtual = item.saldos_agencia_virtual && item.saldo_geracao != saldoNormalAgenciaVirtual && item.saldo_geracao != somaSaldoPontaForaPonta;

        const temAlgumPdf =
            item.arquivo_pdf ||
            item.arquivo_pdf_custo_energia_acl_lp ||
            item.arquivo_pdf_boleto_energia_acl_lp ||
            item.arquivo_pdf_custo_energia_acl_cp ||
            item.arquivo_pdf_boleto_energia_acl_cp ||
            item.arquivo_pdf_custo_gestao_acl ||
            item.arquivo_pdf_boleto_gestao_acl ||
            item.arquivo_pdf_contribuicao_associativa_ccee ||
            item.arquivo_pdf_boleto_contribuicao_associativa_ccee;

        const mensagensImportacao = `DOWNLOAD E IMPORTAÇÃO - ${item.mensagem_ultima_importacao_fatura || "Sem informação"}\nDATA DE PAGAMENTO - ${
            item.mensagem_ultima_importacao_data_pagamento || "Sem informação"
        }\nSALDO - ${item.mensagem_ultima_importacao_saldo || "Sem informação"}`;

        const existeMensagensErro = (String(mensagensImportacao).match(/OK/g) || []).length < 3;

        const linha = (
            <NewTr
                key={`${item.id_unidade_consumidora}-${item.id}-adm-energia`}
                backgroundColorTr={backgroundColorTr}
                backgroundColorTd={backgroundColorTd}
                botoes={botoes}
                delay={indice < 100 ? 0 : indice * 10}
                delayHeightRow={131}
            >
                <Td fontSize="0.85rem" minWidth={60}>
                    {item.id_usuario_implantacao ? (
                        <p
                            style={{
                                backgroundColor: "#257bfb",
                                textAlign: "center",
                                borderRadius: "0.3rem",
                                color: "#ffffff",
                                margin: "0 10px 2px",
                                padding: "2px 5px",
                                fontSize: "0.875rem",
                            }}
                        >
                            Implantação
                        </p>
                    ) : null}
                    {item.possui_itens_sem_tipo ? (
                        <p
                            style={{
                                backgroundColor: "#ffa348",
                                textWrap: "nowrap",
                                textAlign: "center",
                                borderRadius: "0.3rem",
                                color: "#000000",
                                margin: "0 10px 2px",
                                padding: "2px 5px",
                            }}
                        >
                            <i className="fas fa-tasks"></i> Itens sem tipo!
                        </p>
                    ) : null}
                    <p
                        style={{
                            textAlign: "center",
                            padding: "0px 15px 0px 5px",
                            margin: 0,
                        }}
                    >
                        {msgErroImportacaoText.includes("Verifique") ? (
                            <Button
                                style={{ padding: "2px 5px" }}
                                title={msgErroImportacaoText}
                                text="Exibir Erros"
                                solid={true}
                                type={"danger"}
                                event={() => {
                                    setState({
                                        ...state,
                                        exibirErros: true,
                                        idFaturaModalAlertas: null,
                                        conteudoModalAlertaErros: msgErroImportacaoHtml,
                                        modalAlertaOportunidade: false,
                                    });
                                }}
                            />
                        ) : (
                            msgErroImportacaoHtml
                        )}
                        {msgAlertaImportacaoText.includes("Verifique") ? (
                            <Button
                                style={{ padding: "2px 5px", marginTop: 2 }}
                                title={msgAlertaImportacaoText}
                                text={<div style={{ textWrap: "nowrap" }}>{alertasRevisados ? "Alertas Revisados" : "Exibir Alertas"}</div>}
                                solid={true}
                                type={alertasRevisados ? "success" : "warning"}
                                event={() => {
                                    setState({
                                        ...state,
                                        exibirErros: true,
                                        idFaturaModalAlertas: item.id,
                                        conteudoModalAlertaErros: null,
                                        modalAlertaOportunidade: false,
                                    });
                                }}
                            />
                        ) : null}
                        {oportunidades.length ? (
                            <Button
                                style={{ padding: "2px 5px", marginTop: 2 }}
                                title={oportunidades.map((alerta) => alerta.mensagem).join(" | ")}
                                text={<div style={{ textWrap: "nowrap" }}>{oportunidadesRevisadas ? "Oportunidade RC revisada" : "Oportunidade RC"}</div>}
                                solid={true}
                                type="primary"
                                event={() => {
                                    setState({
                                        ...state,
                                        exibirErros: true,
                                        idFaturaModalAlertas: item.id,
                                        conteudoModalAlertaErros: null,
                                        modalAlertaOportunidade: true,
                                    });
                                }}
                            />
                        ) : null}
                    </p>
                    {item.refaturada ? (
                        <p
                            style={{
                                backgroundColor: "#71f793",
                                textWrap: "nowrap",
                                textAlign: "center",
                                borderRadius: "0.3rem",
                                color: "#000000",
                                margin: "2px 10px 2px",
                                fontSize: "0.875rem",
                                padding: "2px 5px",
                            }}
                        >
                            <i className="fa fa-file-invoice-dollar"></i> Refaturada
                        </p>
                    ) : null}
                    <DangerIcon description={"Download Atrasado"} width={150} visible={item.mensagem_download_atrasado} title={item.mensagem_download_atrasado} />
                    {item.datahora_importacao_fatura_distribuidora ? (
                        <p
                            style={{
                                textAlign: "center",
                                color: "#222",
                                margin: "4px 10px 2px",
                                padding: "2px 5px",
                                fontSize: "0.6",
                                lineHeight:'0.85rem',
                                backgroundColor:"#fefefe",
                                borderRadius:"3px"
                            }}
                        >
                            Imp. em {item.datahora_importacao_fatura_distribuidora} pelo {item.nome_usuario_importacao_fatura_distribuidora}
                        </p>
                    ) : null}
                </Td>
                <Td fontSize="0.85rem" minWidth={75} alignCenter>
                    <SolCasaFatura fatura={item} />
                </Td>
                <Td fontSize="0.85rem" minWidth={228} alignCenter>
                    <TableInCell
                        lista={[
                            { cabecalho: "Produção (kWh)", valor: adicionarPontosMilhar(item.quantidade_geracao || 0) },
                            [1, 4].includes(item.id_grupo_faturamento) && (item.unidade_geradora || item.unidade_remota)
                                ? {
                                      cabecalho: (
                                          <span style={{ color: (!item.unidade_geradora && !item.unidade_remota) || parseFloat(item.saldo_geracao) ? null : "#AF1111" }}>
                                              <Button
                                                  style={{ margin: 0, padding: "4px 8px" }}
                                                  title="Visualizar gráfico de saldo de geração (kWh)"
                                                  text={<div style={{ fontSize: "0.7rem" }}>Saldo Produção (kWh)</div>}
                                                  solid={true}
                                                  type={"info"}
                                                  disabled={!item.unidade_geradora && !item.unidade_remota}
                                                  event={() => {
                                                      props.getListaGraficoGeracaoSaldo({ id_cliente: item.id_cliente, id_unidade_consumidora: item.id_unidade_consumidora });
                                                      setState({
                                                          ...state,
                                                          exibirGraficoSaldoGeracao: true,
                                                          itemSelecionado: { id_cliente: item.id_cliente, id_unidade_consumidora: item.id_unidade_consumidora },
                                                      });
                                                  }}
                                              />
                                              {item.unidade_geradora && (
                                                  <Button
                                                      style={{ margin: "2px 0px", padding: 0, height: 30, width: 130, lineHeight: "0.6rem" }}
                                                      type="success"
                                                      solid={true}
                                                      title="Balanço Energético"
                                                      text={
                                                          <div>
                                                              <div style={{ fontSize: "0.7rem", marginBlock: 2 }}>
                                                                  <i className="fas fa-balance-scale mr-2"></i>
                                                                  <span className="mr-2">Balanço</span>
                                                              </div>
                                                              <div style={{ fontSize: "0.7rem" }}>
                                                                  <i className="fas fa-bolt ml-2 mr-1"></i> Energético
                                                              </div>
                                                          </div>
                                                      }
                                                      event={() => setState({ ...state, exibirModalBalancoEnergetico: true, itemSelecionado: item })}
                                                  />
                                              )}
                                          </span>
                                      ),
                                      vertical: true,
                                      valores: [
                                          <span
                                              style={{
                                                  display: "flex",
                                                  justifyContent: "start",
                                                  alignItems: "center",
                                                  paddingLeft: 2,
                                                  paddingTop: 4,
                                                  color:
                                                      (!item.unidade_geradora && !item.unidade_remota) || parseFloat(item.saldo_geracao) //é a soma de p e fp
                                                          ? null
                                                          : "#AF1111",
                                              }}
                                          >
                                              {" P: "}
                                              {item.unidade_geradora || item.unidade_remota ? " " + Math.round(item.saldo_geracao_ponta || 0) : " - "}
                                          </span>,
                                          <span
                                              style={{
                                                  display: "flex",
                                                  justifyContent: "start",
                                                  alignItems: "center",
                                                  paddingLeft: 2,
                                                  paddingTop: 4,
                                                  color:
                                                      (!item.unidade_geradora && !item.unidade_remota) ||
                                                      parseFloat(
                                                          item.saldo_geracao //é a soma de p e fp
                                                      )
                                                          ? null
                                                          : "#AF1111",
                                              }}
                                          >
                                              {" FP: "}
                                              {item.unidade_geradora || item.unidade_remota ? " " + Math.round(item.saldo_geracao_fora_ponta || 0) : " - "}
                                          </span>,
                                          <div
                                              style={{
                                                  display: "flex",
                                                  justifyContent: "start",
                                                  alignItems: "center",
                                                  color: (!item.unidade_geradora && !item.unidade_remota) || parseFloat(item.saldo_geracao) ? null : "#AF1111",
                                              }}
                                          >
                                              Total:{" "}
                                              {item.unidade_geradora || item.unidade_remota ? (
                                                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                      <span className="pr-1">{Math.round(item.saldo_geracao || 0)}</span>
                                                      <ArrowOrEqualIcon
                                                          iconName={
                                                              item.saldo_geracao > item.saldo_geracao_mes_anterior
                                                                  ? "arrowUpGreen"
                                                                  : item.saldo_geracao < item.saldo_geracao_mes_anterior
                                                                    ? "arrowDownRed"
                                                                    : item.saldo_geracao == item.saldo_geracao_mes_anterior
                                                                      ? "equalBlue"
                                                                      : null
                                                          }
                                                      />
                                                  </div>
                                              ) : (
                                                  " - "
                                              )}
                                          </div>,
                                      ],
                                  }
                                : {
                                      cabecalho: (
                                          <span style={{ color: (!item.unidade_geradora && !item.unidade_remota) || parseFloat(item.saldo_geracao) ? null : "#AF1111" }}>
                                              <Button
                                                  style={{ margin: "2px 0 0 0", padding: "4px 8px" }}
                                                  title="Visualizar gráfico de saldo de geração (kWh)"
                                                  text={<div style={{ fontSize: "0.7rem" }}>Saldo Produção (kWh)</div>}
                                                  solid={true}
                                                  type={"info"}
                                                  disabled={!item.unidade_geradora && !item.unidade_remota}
                                                  event={() => {
                                                      props.getListaGraficoGeracaoSaldo({ id_cliente: item.id_cliente, id_unidade_consumidora: item.id_unidade_consumidora });
                                                      setState({
                                                          ...state,
                                                          exibirGraficoSaldoGeracao: true,
                                                      });
                                                  }}
                                              />

                                              <Button
                                                  style={{ margin: 0, marginTop: 2, padding: "4px 8px" }}
                                                  title="Visualizar saldos da agência virtual"
                                                  text={
                                                      <div style={{ display: "flex", fontSize: "0.7rem" }}>
                                                          {saldoFaturaDiferenteAgenciaVirtual ? (
                                                              <AlertIcon
                                                                  height={15}
                                                                  width={15}
                                                                  animationClass={"alerta-triangulo-visualizado pr-2"}
                                                                  title="Saldo da fatura é diferente do que consta na agência virtual, verifique."
                                                                  event={() => {}}
                                                              />
                                                          ) : (
                                                              ""
                                                          )}
                                                          <span style={{ paddingTop: 2, marginBottom: -3 }}>
                                                              Saldo{saldoFaturaDiferenteAgenciaVirtual ? " Ag. " : " Agência "}Virtual
                                                          </span>
                                                      </div>
                                                  }
                                                  solid={true}
                                                  type={"primary"}
                                                  disabled={(!item.unidade_geradora && !item.unidade_remota) || !item.saldos_agencia_virtual}
                                                  event={() => {
                                                      setState({ ...state, saldosAgenciaVirtual: { ...objSaldo, competencia_formatada: item.competencia_formatada } });
                                                  }}
                                              />
                                              {item.unidade_geradora && (
                                                  <Button
                                                      style={{ margin: "2px 0px", padding: 0, height: 30, width: 130, lineHeight: "0.6rem" }}
                                                      type="success"
                                                      solid={true}
                                                      title="Balanço Energético"
                                                      text={
                                                          <div>
                                                              <div style={{ fontSize: "0.7rem", marginBlock: 2 }}>
                                                                  <i className="fas fa-balance-scale mr-2"></i>
                                                                  <span className="mr-2">Balanço</span>
                                                              </div>
                                                              <div style={{ fontSize: "0.7rem" }}>
                                                                  <i className="fas fa-bolt ml-2 mr-1"></i> Energético
                                                              </div>
                                                          </div>
                                                      }
                                                      event={() => setState({ ...state, exibirModalBalancoEnergetico: true, itemSelecionado: item })}
                                                  />
                                              )}
                                          </span>
                                      ),

                                      valor: (
                                          <div
                                              style={{
                                                  color: (!item.unidade_geradora && !item.unidade_remota) || parseFloat(item.saldo_geracao) ? null : "#AF1111",
                                              }}
                                          >
                                              {item.unidade_geradora || item.unidade_remota ? (
                                                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                      <span className="pr-1">{Math.round(item.saldo_geracao || 0)}</span>
                                                      <ArrowOrEqualIcon
                                                          iconName={
                                                              item.saldo_geracao > item.saldo_geracao_mes_anterior
                                                                  ? "arrowUpGreen"
                                                                  : item.saldo_geracao < item.saldo_geracao_mes_anterior
                                                                    ? "arrowDownRed"
                                                                    : item.saldo_geracao == item.saldo_geracao_mes_anterior
                                                                      ? "equalBlue"
                                                                      : null
                                                          }
                                                      />
                                                  </div>
                                              ) : Math.round(item.saldo_geracao || 0) ? (
                                                  <span
                                                      style={{ border: "3px solid #000", backgroundColor: "#ff3f6b", color: "#FFF", padding: "1px 7px", margin: 1 }}
                                                      title={`UC não é geradora e nem remota, porém consta o saldo de ${adicionarPontosMilhar(item.saldo_geracao)}`}
                                                  >
                                                      {adicionarPontosMilhar(item.saldo_geracao)}
                                                  </span>
                                              ) : (
                                                  " - "
                                              )}
                                          </div>
                                      ),
                                      width: 95,
                                  },
                            { cabecalho: "Injetado/Excedente (kWh)", valor: adicionarPontosMilhar(item.energia_excedente || 0) },
                        ]}
                    />
                </Td>
                <Td fontSize="0.85rem" minWidth={50} alignCenter>
                    {item.competencia_formatada}
                </Td>
                <Td fontSize="0.85rem" minWidth={120}>
                    {item.nome_cliente}
                </Td>
                <Td minWidth={150}>
                    <div>
                        {item.data_emissao_nota_fiscal ? (
                            <p
                                style={{
                                    textAlign: "center",
                                    fontSize: "0.8rem",
                                    margin: "0 0 5px 0",
                                }}
                            >
                                Emitida em: {DateFormat.formatarDataSqlParaTela(item.data_emissao_nota_fiscal)}{" "}
                            </p>
                        ) : null}
                    </div>
                    {item.numero_nota_fiscal != null ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "0.8rem",
                                    width: 142,
                                    background: "#fff",
                                    padding: "6px  3px",
                                    borderRadius: "5px",
                                    border: "1px solid #ddd",
                                }}
                            >
                                {`${item.numero_nota_fiscal}${item.serie_nota_fiscal ? " - " + item.serie_nota_fiscal : ""}`}
                            </div>

                            <button
                                title="Copiar conteúdo"
                                onClick={() => copiarTextoClipboard(`${item.numero_nota_fiscal}${item.serie_nota_fiscal ? " - " + item.serie_nota_fiscal : ""}`)}
                                style={{
                                    marginLeft: -30,
                                    backgroundColor: "#fff",
                                    color: "#555",
                                    height: 29,
                                    border: "1px solid #999",
                                    borderRadius: 5,
                                    outline: "none",
                                }}
                            >
                                <i className="far fa-clone"></i>
                            </button>
                        </div>
                    ) : null}
                </Td>

                <Td fontSize="0.85rem" minWidth={200}>
                    {item.nome_unidade_consumidora + " (" + item.nome_concessionaria + ")"}
                </Td>
                <Td fontSize="0.85rem" alignCenter>
                    <TableInCell
                        lista={[
                            { cabecalho: "Tipo Medição", valor: item.sigla_tipo_medicao || " - " },
                            { cabecalho: "Tipo de Transformador", valor: item.nome_tipo_transformador || " - " },
                            {
                                cabecalho: "Grupo de Faturamento",
                                valor: (
                                    <span title={item.sigla_grupo_faturamento}>
                                        {" "}
                                        {item.sigla_grupo_faturamento && item.sigla_grupo_faturamento.indexOf("(") >= 0
                                            ? item.sigla_grupo_faturamento.substring(0, item.sigla_grupo_faturamento.indexOf("("))
                                            : item.sigla_grupo_faturamento || " - "}
                                    </span>
                                ),
                                width: 120,
                            },
                        ]}
                    />
                </Td>
                <Td fontSize="0.85rem" alignCenter>
                    <TableInCell
                        lista={[
                            { cabecalho: "Esperado (%)", valor: isNaN(parseFloat(item.icms_esperado)) ? " - " : adicionarPontosMilhar(item.icms_esperado) },
                            { cabecalho: "Importado (%)", valor: isNaN(parseFloat(item.icms_importado)) ? " - " : adicionarPontosMilhar(item.icms_importado) },
                        ]}
                    />
                </Td>
                <Td fontSize="0.85rem" alignCenter>
                    <TableInCell
                        lista={[
                            {
                                cabecalho: "PIS/PASEP",
                                valores: [
                                    isNaN(parseFloat(item.aliquota_pis_pasep)) ? (
                                        " - "
                                    ) : (
                                        <div
                                            title={existeAlertaAliquotaPisPasep ? "Verifique a alíquota do PIS/PASEP" : ""}
                                            style={{
                                                display: "flex",
                                                height: 20,
                                                width: "100%",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                border: existeAlertaAliquotaPisPasep ? "3px solid #000" : "none",
                                                backgroundColor: existeAlertaAliquotaPisPasep ? "#ff3f6b" : null,
                                                color: existeAlertaAliquotaPisPasep ? "#FFF" : null,
                                            }}
                                        >
                                            {adicionarPontosMilhar(item.aliquota_pis_pasep)}%
                                        </div>
                                    ),
                                    isNaN(parseFloat(item.valor_pis_pasep)) ? (
                                        " - "
                                    ) : (
                                        <div
                                            title={existeAlertaValorPisPasep ? "Verifique o valor do PIS/PASEP" : ""}
                                            style={{
                                                display: "flex",
                                                height: 20,
                                                width: "100%",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                border: existeAlertaValorPisPasep ? "3px solid #000" : "none",
                                                backgroundColor: existeAlertaValorPisPasep ? "#ff3f6b" : null,
                                                color: existeAlertaValorPisPasep ? "#FFF" : null,
                                            }}
                                        >
                                            {"R$ "} {adicionarPontosMilhar(item.valor_pis_pasep)}
                                        </div>
                                    ),
                                ],
                            },
                            {
                                cabecalho: "COFINS",
                                valores: [
                                    isNaN(parseFloat(item.aliquota_cofins)) ? (
                                        " - "
                                    ) : (
                                        <div
                                            title={existeAlertaAliquotaCofins ? "Verifique o valor do COFINS" : ""}
                                            style={{
                                                display: "flex",
                                                height: 20,
                                                width: "100%",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                border: existeAlertaAliquotaCofins ? "3px solid #000" : "none",
                                                backgroundColor: existeAlertaAliquotaCofins ? "#ff3f6b" : null,
                                                color: existeAlertaAliquotaCofins ? "#FFF" : null,
                                            }}
                                        >
                                            {adicionarPontosMilhar(item.aliquota_cofins)}%
                                        </div>
                                    ),
                                    isNaN(parseFloat(item.valor_cofins)) ? (
                                        " - "
                                    ) : (
                                        <div
                                            title={existeAlertaValorPisPasep ? "Verifique o valor do COFINS" : ""}
                                            style={{
                                                display: "flex",
                                                height: 20,
                                                width: "100%",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                border: existeAlertaValorCofins ? "3px solid #000" : "none",
                                                backgroundColor: existeAlertaValorCofins ? "#ff3f6b" : null,
                                                color: existeAlertaValorCofins ? "#FFF" : null,
                                            }}
                                        >
                                            {"R$ "} {adicionarPontosMilhar(item.valor_cofins)}
                                        </div>
                                    ),
                                ],
                            },
                            {
                                cabecalho: "ICMS",
                                valores: [
                                    isNaN(parseFloat(item.icms_importado)) ? (
                                        " - "
                                    ) : (
                                        <div
                                            title={existeAlertaAliquotaIcms ? "Alíquota de ICMS inválida" : ""}
                                            style={{
                                                display: "flex",
                                                height: 20,
                                                width: "100%",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                border: existeAlertaAliquotaIcms ? "3px solid #000" : "none",
                                                backgroundColor: existeAlertaAliquotaIcms ? "#ff3f6b" : null,
                                                color: existeAlertaAliquotaIcms ? "#FFF" : null,
                                            }}
                                        >
                                            {adicionarPontosMilhar(item.icms_importado)}%
                                        </div>
                                    ),
                                    isNaN(parseFloat(item.valor_icms)) ? (
                                        " - "
                                    ) : (
                                        <div
                                            title={existeAlertaValorIcms ? "Verifique o valor do ICMS" : ""}
                                            style={{
                                                display: "flex",
                                                height: 20,
                                                width: "100%",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                border: existeAlertaValorIcms ? "3px solid #000" : "none",
                                                backgroundColor: existeAlertaValorIcms ? "#ff3f6b" : null,
                                                color: existeAlertaValorIcms ? "#FFF" : null,
                                            }}
                                        >
                                            {"R$ "}
                                            {adicionarPontosMilhar(item.valor_icms)}
                                        </div>
                                    ),
                                ],
                            },
                        ]}
                    />
                </Td>
                <Td fontSize="0.85rem" alignCenter>
                    <TableInCell
                        lista={[
                            {
                                cabecalho: "Custo de Energia ACL (R$)",
                                valor:
                                    item.id_tipo_mercado == 2 ? (
                                        <div
                                            title={tarifaMediaLiquidaInvalida ? "TML maior que R$ 6, verifique os valores destacados" : ""}
                                            style={{
                                                padding: 10,
                                                border: !item.id || parseFloat(item.custo_energia_acl) > 0 ? "none" : "3px solid #000",
                                                backgroundColor: tarifaMediaLiquidaInvalida ? "#ff3f6b" : null,
                                                color: tarifaMediaLiquidaInvalida ? "#fff" : null,
                                                display: "flex",
                                                flexWrap: "nowrap",
                                                width: "100%",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "1.4rem",
                                            }}
                                        >
                                            {adicionarPontosMilhar(item.custo_energia_acl)}
                                        </div>
                                    ) : (
                                        adicionarPontosMilhar(item.custo_energia_acl)
                                    ),
                            },
                            {
                                cabecalho: "Custo de Gestão ACL (R$)",
                                valor:
                                    item.id_tipo_mercado == 2 ? (
                                        <div
                                            title={tarifaMediaLiquidaInvalida ? "TML maior que R$ 6, verifique os valores destacados" : ""}
                                            style={{
                                                padding: 10,
                                                border: !item.id || parseFloat(item.custo_gestao_acl) > 0 ? "none" : "3px solid #000",
                                                backgroundColor: tarifaMediaLiquidaInvalida ? "#ff3f6b" : null,
                                                color: tarifaMediaLiquidaInvalida ? "#fff" : null,
                                                display: "flex",
                                                flexWrap: "nowrap",
                                                width: "100%",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "1.4rem",
                                            }}
                                        >
                                            {adicionarPontosMilhar(item.custo_gestao_acl)}
                                        </div>
                                    ) : (
                                        adicionarPontosMilhar(item.custo_gestao_acl)
                                    ),
                            },
                            {
                                cabecalho: "Tx. de Contribuição CCEE (R$)",
                                valor:
                                    item.id_tipo_mercado == 2 ? (
                                        <div
                                            title={tarifaMediaLiquidaInvalida ? "TML maior que R$ 6, verifique os valores destacados" : ""}
                                            style={{
                                                padding: 10,
                                                border: !item.id || parseFloat(item.contribuicao_associativa_ccee) > 0 ? "none" : "3px solid #000",
                                                backgroundColor: tarifaMediaLiquidaInvalida ? "#ff3f6b" : null,
                                                color: tarifaMediaLiquidaInvalida ? "#fff" : null,
                                                display: "flex",
                                                flexWrap: "nowrap",
                                                width: "100%",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "1.4rem",
                                            }}
                                        >
                                            {adicionarPontosMilhar(item.contribuicao_associativa_ccee)}
                                        </div>
                                    ) : (
                                        adicionarPontosMilhar(item.contribuicao_associativa_ccee)
                                    ),
                            },
                        ]}
                    />
                </Td>
                <Td fontSize="0.85rem" minWidth={50} alignCenter>
                    <TableInCell
                        lista={[
                            { cabecalho: "Fatura (R$)", valor: adicionarPontosMilhar(item.total > 0 ? item.total : 0) },
                            {
                                cabecalho: "Importado (R$)",
                                valor: (
                                    <div
                                        title={tarifaMediaLiquidaInvalida ? "TML maior que R$ 6, verifique os valores destacados" : ""}
                                        style={{
                                            padding: 2,
                                            border: tarifaMediaLiquidaInvalida ? "3px solid #000" : "none",
                                            backgroundColor: tarifaMediaLiquidaInvalida ? "#ff3f6b" : null,
                                            color: tarifaMediaLiquidaInvalida ? "#fff" : null,
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "1.4rem",
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.valor_fatura || 0)}
                                    </div>
                                ),
                            },
                        ]}
                    />
                </Td>
                <Td fontSize={tarifaMediaLiquidaInvalida ? "0.9rem" : "0.85rem"} minWidth={50} alignCenter>
                    <TableInCell
                        lista={[
                            {
                                cabecalho: "Total (kWh)",
                                valor: (
                                    <div
                                        title={tarifaMediaLiquidaInvalida ? "TML maior que R$ 6, verifique os valores destacados" : ""}
                                        style={{
                                            padding: 2,
                                            border: tarifaMediaLiquidaInvalida ? "3px solid #000" : "none",
                                            backgroundColor: tarifaMediaLiquidaInvalida ? "#ff3f6b" : null,
                                            color: tarifaMediaLiquidaInvalida ? "#fff" : null,
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "1.4rem",
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.energia || 0)}
                                    </div>
                                ),
                            },
                            { cabecalho: "Ponta (kWh)", valor: adicionarPontosMilhar(item.energia_ponta || 0) },
                            { cabecalho: "Fora Ponta (kWh)", valor: adicionarPontosMilhar(item.energia_fora_ponta || 0) },
                            { cabecalho: "Reservado (kWh)", valor: adicionarPontosMilhar(item.energia_reservado || 0) },
                        ]}
                    />
                </Td>
                <Td fontSize="0.85rem" minWidth={50} alignCenter>
                    <TableInCell
                        lista={[
                            { cabecalho: "Fora Ponta Contrato Cadastro (kW)", valor: adicionarPontosMilhar(item.contrato_demanda_fora_ponta) || " - " },
                            {
                                cabecalho: "Fora Ponta Contrato Fatura (kW)",
                                valor: (
                                    <div
                                        style={{
                                            padding: 2,
                                            height: "1.4rem",
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            border:
                                                parseInt(item.demanda_contratada_fora_ponta) &&
                                                parseInt(item.contrato_demanda_fora_ponta) &&
                                                parseInt(item.demanda_contratada_fora_ponta) != parseInt(item.contrato_demanda_fora_ponta)
                                                    ? "3px solid #000"
                                                    : "none",
                                            backgroundColor:
                                                parseInt(item.demanda_contratada_fora_ponta) &&
                                                parseInt(item.contrato_demanda_fora_ponta) &&
                                                parseInt(item.demanda_contratada_fora_ponta) != parseInt(item.contrato_demanda_fora_ponta)
                                                    ? "#ff3f6b"
                                                    : null,
                                            color:
                                                parseInt(item.demanda_contratada_fora_ponta) &&
                                                parseInt(item.contrato_demanda_fora_ponta) &&
                                                parseInt(item.demanda_contratada_fora_ponta) != parseInt(item.contrato_demanda_fora_ponta)
                                                    ? "#FFF"
                                                    : null,
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.demanda_contratada_fora_ponta) || " - "}
                                    </div>
                                ),
                            },
                            { cabecalho: "Ponta Contrato Cadastro (kW)", valor: adicionarPontosMilhar(item.contrato_demanda_ponta) || " - " },
                            {
                                cabecalho: "Ponta Contrato Fatura (kW)",
                                valor: (
                                    <div
                                        style={{
                                            padding: 2,
                                            height: "1.4rem",
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            border:
                                                parseInt(item.demanda_contratada_ponta) &&
                                                parseInt(item.contrato_demanda_ponta) &&
                                                parseInt(item.demanda_contratada_ponta) != parseInt(item.contrato_demanda_ponta)
                                                    ? "3px solid #000"
                                                    : "none",
                                            backgroundColor:
                                                parseInt(item.demanda_contratada_ponta) &&
                                                parseInt(item.contrato_demanda_ponta) &&
                                                parseInt(item.demanda_contratada_ponta) != parseInt(item.contrato_demanda_ponta)
                                                    ? "#ff3f6b"
                                                    : null,
                                            color:
                                                parseInt(item.demanda_contratada_ponta) &&
                                                parseInt(item.contrato_demanda_ponta) &&
                                                parseInt(item.demanda_contratada_ponta) != parseInt(item.contrato_demanda_ponta)
                                                    ? "#FFF"
                                                    : null,
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.demanda_contratada_ponta) || " - "}
                                    </div>
                                ),
                            },
                        ]}
                    />
                </Td>

                <Td fontSize="0.85rem" minWidth={50} alignCenter>
                    <TableInCell
                        lista={[
                            {
                                cabecalho: "Ponta",
                                valores: [
                                    <div
                                        style={{
                                            padding: 2,
                                            border: alertaDemandaFaturadaMaior5pc.ponta ? "3px solid #000" : "none",
                                            backgroundColor: alertaDemandaFaturadaMaior5pc.ponta ? "#ff3f6b" : null,
                                            color: alertaDemandaFaturadaMaior5pc.ponta ? "#FFF" : null,
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "1.4rem",
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.demanda_ponta || 0) + " kW"}
                                    </div>,
                                    <div
                                        title={tarifaMediaLiquidaInvalida ? "TML maior que R$ 6, verifique os valores destacados" : ""}
                                        style={{
                                            padding: 2,
                                            border: tarifaMediaLiquidaInvalida ? "3px solid #000" : "none",
                                            backgroundColor: tarifaMediaLiquidaInvalida ? "#ff3f6b" : null,
                                            color: tarifaMediaLiquidaInvalida ? "#fff" : null,
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "1.4rem",
                                        }}
                                    >
                                        {"R$ " + adicionarPontosMilhar(item.valor_demanda_ponta || 0)}
                                    </div>,
                                ],
                            },
                            {
                                cabecalho: "Fora Ponta",
                                valores: [
                                    <div
                                        style={{
                                            padding: 2,
                                            border: alertaDemandaFaturadaMaior5pc.fora_ponta ? "3px solid #000" : "none",
                                            backgroundColor: alertaDemandaFaturadaMaior5pc.fora_ponta ? "3px solid #ff3f6b" : null,
                                            color: alertaDemandaFaturadaMaior5pc.fora_ponta ? "3px solid #FFF" : null,
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "1.4rem",
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.demanda || 0) + " kW"}
                                    </div>,
                                    <div
                                        title={tarifaMediaLiquidaInvalida ? "TML maior que R$ 6, verifique os valores destacados" : ""}
                                        style={{
                                            padding: 2,
                                            border: tarifaMediaLiquidaInvalida ? "3px solid #000" : "none",
                                            backgroundColor: tarifaMediaLiquidaInvalida ? "#ff3f6b" : null,
                                            color: tarifaMediaLiquidaInvalida ? "#fff" : null,
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "1.4rem",
                                        }}
                                    >
                                        {"R$ " + adicionarPontosMilhar(item.valor_demanda || 0)}
                                    </div>,
                                ],
                            },
                            {
                                cabecalho: "Reservado",
                                valores: [
                                    <div
                                        style={{
                                            padding: 2,
                                            border: alertaDemandaFaturadaMaior5pc.reservado ? "3px solid #000" : "none",
                                            backgroundColor: alertaDemandaFaturadaMaior5pc.reservado ? "#ff3f6b" : null,
                                            color: alertaDemandaFaturadaMaior5pc.reservado ? "#FFF" : null,
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "1.4rem",
                                        }}
                                    >
                                        {adicionarPontosMilhar(item.demanda_reservado || 0) + " kW"}
                                    </div>,
                                    <div
                                        title={tarifaMediaLiquidaInvalida ? "TML maior que R$ 6, verifique os valores destacados" : ""}
                                        style={{
                                            padding: 2,
                                            border: tarifaMediaLiquidaInvalida ? "3px solid #000" : "none",
                                            backgroundColor: tarifaMediaLiquidaInvalida ? "#ff3f6b" : null,
                                            color: tarifaMediaLiquidaInvalida ? "#fff" : null,
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "1.4rem",
                                        }}
                                    >
                                        {"R$ " + adicionarPontosMilhar(item.valor_demanda_reservado || 0)}
                                    </div>,
                                ],
                            },
                            {
                                cabecalho: "Demanda G",
                                valores: [
                                    adicionarPontosMilhar(item.demanda_geracao || 0) + " kW",
                                    <div
                                        title={tarifaMediaLiquidaInvalida ? "TML maior que R$ 6, verifique os valores destacados" : ""}
                                        style={{
                                            padding: 2,
                                            border: tarifaMediaLiquidaInvalida ? "3px solid #000" : "none",
                                            backgroundColor: tarifaMediaLiquidaInvalida ? "#ff3f6b" : null,
                                            color: tarifaMediaLiquidaInvalida ? "#fff" : null,
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            width: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            height: "1.4rem",
                                        }}
                                    >
                                        {"R$ " + adicionarPontosMilhar(item.valor_demanda_geracao || 0)}
                                    </div>,
                                ],
                            },
                        ]}
                    />
                </Td>
                <Td fontSize="0.85rem" minWidth={50} alignCenter>
                    {adicionarPontosMilhar(item.energia_reativo || 0)}
                </Td>
                <Td fontSize="0.85rem" minWidth={50} alignCenter>
                    <div
                        title={tarifaMediaLiquidaInvalida ? "TML maior que R$ 6, verifique os valores destacados" : ""}
                        style={{
                            padding: 2,
                            border: tarifaMediaLiquidaInvalida ? "3px solid #000" : "none",
                            backgroundColor: tarifaMediaLiquidaInvalida ? "#ff3f6b" : null,
                            color: tarifaMediaLiquidaInvalida ? "#fff" : null,
                            display: "flex",
                            flexWrap: "nowrap",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "1.4rem",
                        }}
                    >
                        {adicionarPontosMilhar(item.gasto_reativo || 0)}
                    </div>
                </Td>
                <Td fontSize="0.85rem" minWidth={50} alignCenter>
                    {tarifa}
                </Td>
                <Td alignCenter minWidth={50}>
                    {temAlgumPdf ? (
                        <ButtonTable
                            style={{ margin: 0 }}
                            title="Visualizar PDF"
                            type={"primary"}
                            icon={"fas fa-file-pdf"}
                            visible={true}
                            event={() => {
                                if (item.id_tipo_mercado == 2) {
                                    return setState({ ...state, exibirModalSelecaoFatura: true, itemPdfSelecionado: item });
                                }
                                props.buscarPdf(
                                    item.id,
                                    `Fatura_UC-${item.nome_unidade_consumidora.replace(/\./g, "").split("-")[0].trim()}_${String(item.competencia).substring(4, 6)}-${String(
                                        item.competencia
                                    ).substring(0, 4)}`
                                );
                                props.setArquivoPDF();
                            }}
                        />
                    ) : existeMensagensErro ? (
                        <ButtonTable
                            solid={true}
                            style={{ margin: 0, borderRadius: "0.3rem" }}
                            title={mensagensImportacao}
                            type={"danger"}
                            icon={"fas fa-exclamation"}
                            visible={true}
                            event={() => ({})}
                        />
                    ) : null}
                </Td>
            </NewTr>
        );

        if (getOnlyComponent) {
            return linha;
        }

        return {
            componente: linha,
            msgErroImportacaoText,
            msgAlertaImportacaoText,
            id_usuario_implantacao: item.id_usuario_implantacao,
            nome_unidade_consumidora: item.nome_unidade_consumidora,
            nome_concessionaria: item.nome_concessionaria,
            data_emissao_nota_fiscal: item.data_emissao_nota_fiscal,
            numero_nota_fiscal: item.numero_nota_fiscal,
            serie_nota_fiscal: item.serie_nota_fiscal,
        };
    }

    function handleGerarXlsx() {
        //criar função que faz download múltiplo
        const dados = faturasFiltradas.map((item) => {
            //FORMATA COMPETENCIA
            const retorno = {};

            retorno["Status Imp. Fatura"] = item.visualizacao_disponivel_cliente ? "Validado" : "Não Importado";
            retorno["Status Imp. Prod. Solar"] = parseFloat(item.quantidade_geracao || 0) <= 0 ? "Importação Solar Pendente" : "Geração Solar Importada";
            retorno["Produção (kWh)"] = adicionarPontosMilhar(item.quantidade_geracao || 0) + " kWh";
            retorno["Saldo Produção (kWh)"] =
                item.geracao || item.remota
                    ? [1, 4].includes(item.id_grupo_faturamento)
                        ? `P: ${Math.round(item.saldo_geracao_ponta || 0) + " kWh"} | FP: ${
                              Math.round(item.saldo_geracao_fora_ponta || 0) + " kWh"
                          } | Total: ${Math.round(item.saldo_geracao || 0) + " kWh"}`
                        : "0"
                    : "";
            retorno["Injetado/Excedente (kWh)"] = adicionarPontosMilhar(item.energia_excedente || 0) + " kWh";
            retorno["Competência"] = item.competencia_formatada;
            retorno["Cliente"] = item.nome_cliente;
            retorno["Data de Emissão da Nota Fiscal"] = item.data_emissao_nota_fiscal ? `${DateFormat.formatarDataSqlParaTela(item.data_emissao_nota_fiscal)}` : "";
            retorno["Nº da Nota Fiscal"] = item.numero_nota_fiscal ? `${item.numero_nota_fiscal}${item.serie_nota_fiscal ? " - " + item.serie_nota_fiscal : ""}` : "";
            retorno["Unidade Consumidora"] = item.nome_unidade_consumidora + " (" + item.nome_concessionaria + ")";
            retorno["Tipo Medição"] = item.sigla_tipo_medicao || "";
            retorno["Tipo de Transformador"] = item.nome_tipo_transformador || "";
            retorno["Grupo de Faturamento"] = item.sigla_grupo_faturamento || "";
            retorno["ICMS Esperado (%)"] = isNaN(parseFloat(item.icms_esperado)) ? "" : adicionarPontosMilhar(item.icms_esperado) + "%";
            retorno["ICMS Importado (%)"] = isNaN(parseFloat(item.icms_importado)) ? "" : adicionarPontosMilhar(item.icms_importado) + "%";
            retorno["PIS/PASEP"] = `R$ ${adicionarPontosMilhar(item.valor_pis_pasep) || 0} ${
                item.aliquota_pis_pasep ? "(" + adicionarPontosMilhar(item.aliquota_pis_pasep) + "%)" : ""
            }`;
            retorno["COFINS"] = `R$ ${adicionarPontosMilhar(item.valor_cofins) || 0} ${item.aliquota_cofins ? "(" + adicionarPontosMilhar(item.aliquota_cofins) + "%)" : ""}`;
            retorno["ICMS"] = `R$ ${adicionarPontosMilhar(item.valor_icms) || 0} ${item.icms_importado ? "(" + adicionarPontosMilhar(item.icms_importado) + "%)" : ""}`;
            retorno["Custo de Energia ACL (R$)"] = "R$ " + adicionarPontosMilhar(item.custo_energia_acl || 0);
            retorno["Custo de Gestão ACL (R$)"] = "R$ " + adicionarPontosMilhar(item.custo_gestao_acl || 0);
            retorno["Tx. de Contribuição CCEE (R$)"] = "R$ " + adicionarPontosMilhar(item.contribuicao_associativa_ccee || 0);
            retorno["Fatura (R$)"] = "R$ " + adicionarPontosMilhar(item.total > 0 ? item.total : 0);
            retorno["Importado (R$)"] = "R$ " + adicionarPontosMilhar(item.valor_fatura || 0);
            retorno["Total (kWh)"] = adicionarPontosMilhar(item.energia || 0) + " kWh";
            retorno["Ponta (kWh)"] = adicionarPontosMilhar(item.energia_ponta || 0) + " kWh";
            retorno["Fora Ponta (kWh)"] = adicionarPontosMilhar(item.energia_fora_ponta || 0) + " kWh";
            retorno["Reservado (kWh)"] = adicionarPontosMilhar(item.energia_reservado || 0) + " kWh";
            retorno["Fora Ponta Contrato Cadastro (kW)"] = adicionarPontosMilhar(item.contrato_demanda_fora_ponta || 0) + " kW";
            retorno["Fora Ponta Contrato Fatura (kW)"] = adicionarPontosMilhar(item.demanda_contratada_fora_ponta || 0) + " kW";
            retorno["Ponta Contrato Cadastro (kW)"] = adicionarPontosMilhar(item.contrato_demanda_ponta || 0) + " kW";
            retorno["Ponta Contrato Fatura (kW)"] = adicionarPontosMilhar(item.demanda_contratada_ponta || 0) + " kW";
            retorno["Ponta"] = `${adicionarPontosMilhar(item.demanda_ponta || 0) + " kW"} (${"R$ " + adicionarPontosMilhar(item.valor_demanda_ponta || 0)})`;
            retorno["Fora Ponta"] = `${adicionarPontosMilhar(item.demanda || 0) + " kW"} (${"R$ " + adicionarPontosMilhar(item.valor_demanda || 0)})`;
            retorno["Reservado"] = `${adicionarPontosMilhar(item.demanda_reservado || 0) + " kW"} (${"R$ " + adicionarPontosMilhar(item.valor_demanda_reservado || 0)})`;
            retorno["Demanda G"] = `${adicionarPontosMilhar(item.demanda_geracao || 0) + " kW"} (${"R$ " + adicionarPontosMilhar(item.valor_demanda_geracao || 0)})`;
            retorno["E. Reativo (kvarh)"] = adicionarPontosMilhar(item.energia_reativo || 0) + " kvarh";
            retorno["Gasto Reativo (R$)"] = "R$ " + adicionarPontosMilhar(item.gasto_reativo || 0);
            const tarifaPorHorario =
                parseFloat(item.tarifa_energia_ponta) >= 0 || parseFloat(item.tarifa_energia_fora_ponta) >= 0 || parseFloat(item.tarifa_energia_horario_reservado) >= 0;
            retorno["Tarifas"] = tarifaPorHorario
                ? `T.P: ${parseFloat(item.tarifa_energia_ponta) >= 0 ? "R$ " + adicionarPontosMilhar(item.tarifa_energia_ponta, 4) : ""} | T.FP: ${
                      parseFloat(item.tarifa_energia_fora_ponta) >= 0 ? "R$ " + adicionarPontosMilhar(item.tarifa_energia_fora_ponta, 4) : ""
                  } | T.R: ${parseFloat(item.tarifa_energia_horario_reservado) >= 0 ? "R$ " + adicionarPontosMilhar(item.tarifa_energia_horario_reservado, 4) : ""}`
                : `Tarifa: ${"R$ " + adicionarPontosMilhar(item.tarifa_economia || 0, 4)}`;
            retorno["Tarifa Média Líquida"] = parseFloat(item.tarifa_media_liquida) >= 0 ? "R$ " + adicionarPontosMilhar(item.tarifa_media_liquida, 4) : "";
            retorno["Tarifa Média Bruta"] = parseFloat(item.tarifa_media_bruta) >= 0 ? "R$ " + adicionarPontosMilhar(item.tarifa_media_bruta, 4) : "";
            retorno["PDF"] =
                (item.arquivo_pdf ||
                    item.arquivo_pdf_custo_energia_acl_cp ||
                    item.arquivo_pdf_custo_energia_acl_lp ||
                    item.arquivo_pdf_custo_gestao_acl ||
                    item.arquivo_pdf_contribuicao_associativa_ccee) &&
                (!(item.erros_importacao || []).length || item.importacao_validada || props.usuarioLogado.administrador)
                    ? "Disponível"
                    : "Indisponível";
            retorno["Cód. Barras"] =
                item.arquivo_pdf && (!(item.erros_importacao || []).length || item.importacao_validada || props.usuarioLogado.administrador) ? "Disponível" : "Indisponível";

            return retorno;
        });
        props.gerarXlsx({ nomeArquivo: "Faturas", dados });
    }

    function montarLinhas(faturas) {
        const linhas = [];

        for (const fatura of faturas) {
            const registro = buildRow({ item: fatura });
            const {
                componente,
                id_usuario_implantacao,
                msgErroImportacaoText,
                msgAlertaImportacaoText,
                data_emissao_nota_fiscal,
                numero_nota_fiscal,
                serie_nota_fiscal,
                nome_unidade_consumidora,
                nome_concessionaria,
            } = registro;
            const totalCelulas = componente.props.children.length;
            let linhaModificada = Array.from(componente.props.children).splice(0, totalCelulas - 1);
            linhaModificada = React.Children.map(linhaModificada, (child, index) => {
                // Extrai propriedades personalizadas da linha original
                const backgroundColorTd = componente.props.backgroundColorTd || "";
                const backgroundColorTr = componente.props.backgroundColorTr || "";

                // 0 = Msg Erro Importação
                if (index === 0) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div>
                                {id_usuario_implantacao ? (
                                    <p
                                        style={{
                                            backgroundColor: "#257bfb",
                                            textAlign: "center",
                                            borderRadius: "0.3rem",
                                            color: "#fff",
                                            margin: "2px 10px 2px 2px",
                                            padding: "2px 5px",
                                        }}
                                    >
                                        Implantação
                                    </p>
                                ) : null}
                                <p
                                    style={{
                                        textAlign: "center",
                                        margin: "2px 10px 2px 2px",
                                        padding: "2px 5px",
                                    }}
                                >
                                    {msgErroImportacaoText.length > 30 ? msgErroImportacaoText.substring(0, 30) + "..." : msgErroImportacaoText}
                                </p>
                                <p
                                    style={{
                                        textAlign: "center",
                                        margin: "2px 10px 2px 2px",
                                        padding: "2px 5px",
                                    }}
                                >
                                    {msgAlertaImportacaoText.length > 30 ? msgAlertaImportacaoText.substring(0, 30) + "..." : msgAlertaImportacaoText}
                                </p>
                            </div>
                        ),
                    });
                }

                if (index === 2) {
                    //  Clona o componente da célula 2 e limpa os botões da prop `lista`
                    const listaOriginal = child.props.children.props.lista || [];

                    // recria a lista sem os botões
                    const novaLista = listaOriginal.map((item, i) => {
                        if (i === 1) {
                            item.cabecalho = "Saldo Produção (kWh)";
                        }
                        return item;
                    });

                    return React.cloneElement(child, {
                        ...child.props,
                        lista: novaLista,
                    });
                }

                // 5 = número nota fiscal e série
                if (index === 5) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div
                                style={{
                                    textAlign: "center",
                                }}
                            >
                                {data_emissao_nota_fiscal ? (
                                    <p
                                        style={{
                                            textAlign: "center",
                                            fontSize: "0.8rem",
                                            margin: "0 0 5px 0",
                                        }}
                                    >
                                        Emitida em: {DateFormat.formatarDataSqlParaTela(data_emissao_nota_fiscal)}{" "}
                                    </p>
                                ) : null}
                                <p
                                    style={{
                                        textAlign: "center",
                                        fontSize: "0.8rem",
                                        margin: "0 0 5px 0",
                                    }}
                                >
                                    {" "}
                                    {numero_nota_fiscal != null && serie_nota_fiscal != null ? numero_nota_fiscal + "-" + serie_nota_fiscal : " - "}
                                </p>
                            </div>
                        ),
                    });
                }

                // 6 = UC
                if (index === 6) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div
                                style={{
                                    textAlign: "center",
                                }}
                            >
                                {nome_unidade_consumidora.length > 20
                                    ? `${nome_unidade_consumidora.substring(0, 20)}... (${nome_concessionaria})`
                                    : `${nome_unidade_consumidora} (${nome_concessionaria})`}
                            </div>
                        ),
                    });
                }

                // Retorna o elemento sem alterações, mas aplica os estilos personalizados
                return React.cloneElement(child, {
                    backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                });
            });
            const linhaSemColunaBotoes = React.cloneElement(componente, {
                ...componente.props,
                children: linhaModificada,
                botoes: [],
            });

            linhas.push(linhaSemColunaBotoes);
        }
        return linhas;
    }

    function handleClickButtonTable({ item, modoTela }) {
        const itemForm = {
            ...item,
            competencia: item.competencia_formatada,
            valor_fatura: FormatUtils.formatarValorTela(item.valor_fatura, 2),
        };
        props.setModoTela(modoTela, { ...itemForm });
        props.initForm({ ...itemForm });
    }

    function montarBotoes(item) {
        const botoes = [];

        if (item.importado || item.arquivo_pdf) {
            if (props.usuarioLogado && !props.usuarioLogado.acesso_cliente) {
                botoes.push(
                    {
                        type: "success",
                        icon: "fas fa-sync",
                        disabled: !item.arquivo_pdf || !props.usuarioLogado.acesso_fatura_reprocessar,
                        event: () => {
                            if (item.id) {
                                props.reprocessar(item.id);
                            }
                        },
                    },

                    {
                        type: "primary",
                        icon: "fas fa-eye",
                        disabled: !props.usuarioLogado.acesso_fatura_visualizar,
                        event: () => handleClickButtonTable({ item, modoTela: "visualizacao" }),
                    },

                    {
                        type: "warning",
                        icon: "fas fa-pencil-alt",
                        disabled: !usuarioAcessoEditar,
                        event: () => handleClickButtonTable({ item, modoTela: "cadastro" }),
                    },
                    {
                        type: "danger",
                        icon: "fas fa-trash-alt",
                        disabled: item.importacao_validada && !usuarioAcessoEditar,
                        event: () => handleClickButtonTable({ item, modoTela: "exclusao" }),
                    }
                );
            } else {
                if (usuarioAcessoEditar) {
                    botoes.push({
                        type: "success",
                        icon: "fas fa-eye",
                        event: () => handleClickButtonTable({ item, modoTela: "visualizacao" }),
                    });
                }
            }
        } else {
            if (usuarioAcessoEditar) {
                botoes.push({
                    style: { width: 90 },
                    text: "Importar",
                    type: "success",
                    solid: true,
                    disabled: !usuarioAcessoEditar,
                    event: () => handleClickButtonTable({ item, modoTela: "cadastro" }),
                });
                if (item.id) {
                    botoes.push({
                        style: { width: 90 },
                        text: "Excluir",
                        type: "danger",
                        solid: true,
                        disabled: item.importacao_validada && !usuarioAcessoEditar,
                        event: () => handleClickButtonTable({ item, modoTela: "exclusao" }),
                    });
                }
            }
        }
        return botoes;
    }

    function fecharModalAlertaErros() {
        setState({ ...state, exibirErros: false, conteudoModalAlertaErros: null, idFaturaModalAlertas: null, modalAlertaOportunidade: false });
    }

    async function alterarStatusAlertaItem(item, alerta, verificado) {
        const chave = `${item.id}|${alerta.tipo}|${alerta.mensagem}`;
        if (alertaAlterando) return;
        if (!window.confirm("Realmente deseja alterar o status do alerta?")) return;
        setAlertaAlterando(chave);
        try {
            await props.alterarStatusAlerta({
                id_fatura: item.id,
                tipo: alerta.tipo,
                mensagem: alerta.mensagem,
                verificado,
            });
        } catch (erro) {
            // o toast de erro é exibido na action
        } finally {
            setAlertaAlterando(null);
        }
    }

    function filtrarImportacaoSolar(item) {
        const verde = state.statusImportacaoSolarVerde;
        const vermelha = state.statusImportacaoSolarVermelha;
        const isGeradora = item.unidade_geradora || item.geradora_e_remota;
        const quantidadeGeracao = parseFloat(item.quantidade_geracao || 0);

        if (!verde && !vermelha) return true;

        if (!isGeradora) return false;

        if (verde && vermelha) return true;

        if (vermelha) return quantidadeGeracao <= 0;

        if (verde) return quantidadeGeracao > 0;

        return false;
    }

    function listarUCsFiltradas() {
        const ucsFiltradas = props.listaUnidadeConsumidora.filter(
            (item) =>
                ((!props.filtro.id_cliente && props.usuarioLogado && props.usuarioLogado.administrador) || item.id_cliente == props.filtro.id_cliente) &&
                (!props.filtro.id_grupo_faturamento || item.id_grupo_faturamento == props.filtro.id_grupo_faturamento) &&
                ((props.filtro.irrigante && item.irrigante) || (props.filtro.naoIrrigante && !item.irrigante))
        );
        return ucsFiltradas;
    }

    function copiarTextoClipboard(texto) {
        navigator.clipboard
            .writeText(texto)
            .then(() => {
                setSuccess(`Conteúdo copiado: ${texto}`);
            })
            .catch((err) => {
                setError("Não foi possível copiar o conteúdo");
            });
    }

    function getObjetoAlertaDemanda(item) {
        const alertaComObjeto = (item.alertas || []).find((alerta) => alerta.objeto) || "{}";
        return alertaComObjeto.objeto ? JSON.parse(alertaComObjeto.objeto) : {};
    }

    function gerarRelatorio({ statusAtivos, cabecalho, rodape, linhas }) {
        const cabecalhoTabela = typeof cabecalho.type === "function" ? cabecalho.type(cabecalho.props) : cabecalho;
        const rodapeTabela = typeof rodape.type === "function" ? rodape.type(rodape.props) : rodape;
        // props.setAguardando(true);
        const ucsSelecionadas = props.listaUnidadeConsumidora.filter((item) => props.filtro.unidades_consumidoras.find((uc) => uc.value == item.id));
        const nomesUcsSelecionadas = String(ucsSelecionadas.map((item) => item.valor));

        const totalCelulas = cabecalhoTabela.props.children.length;
        const linhaModificada = Array.from(cabecalhoTabela.props.children).splice(0, totalCelulas - 1);

        const cabecalhoSemColunasBotoes = (
            <NewTr>
                {linhaModificada.map((el, i) => {
                    const copia = React.cloneElement(
                        el,
                        {
                            key: i,
                            sticky: false,
                            style: { fontSize: "0.85rem", paddingTop: 30 },
                        },
                        [...el.props.children]
                    );
                    return copia;
                })}
            </NewTr>
        );

        const filtro = (
            <b fontSize="0.85rem">
                Cliente:
                {` ${(props.listaCliente.find((cliente) => cliente.id == props.filtro.id_cliente) || {}).valor || "Todos"} - `}
                UCs:
                {` ${nomesUcsSelecionadas.length ? nomesUcsSelecionadas : "Todas"} - `}
                Ano:{" " + (props.filtro.ano || "") + " - "}
                Mês:
                {` ${(props.listaMeses.find((mes) => mes.id == props.filtro.mes) || {}).valor || "Todos"} - `}
                Concessionária:
                {` ${(props.listaConcessionaria.find((concessionaria) => concessionaria.id == props.filtro.id_concessionaria) || {}).valor || "Todas"} - `}
                UCs: Filtro por Status: {String(statusAtivos).replace(/\,/g, ", ")}
            </b>
        );
        const html = ReactDOMServer.renderToString(
            <TabelaFaturaAdmPDF
                dadosImpressao={{
                    filtro,
                    rodape: rodapeTabela,
                    cabecalhoSemColunasBotoes,
                    linhas,
                }}
            />
        );

        props.gerarRelatorio({ html, landscape: true, scale: 0.5 });
    }
}

const mapStateToProps = (state) => {
    return {
        sessao: state.auth.usuario,
        usuarioLogado: state.auth.usuarioLogado,
        modoTela: state.fatura.modoTela,
        aguardando: state.fatura.aguardando,
        filtro: state.fatura.filtro,
        lista: state.fatura.lista,
        listaUcFaturasRedirecionamento: state.fatura.listaUcFaturasRedirecionamento,
        listaGraficoGeracaoSaldo: state.fatura.listaGraficoGeracaoSaldo,
        listaCliente: state.fatura.listaCliente,
        listaConcessionaria: state.fatura.listaConcessionaria,
        listaUnidadeConsumidora: state.fatura.listaUnidadeConsumidora,
        listaProdutoTipo: state.fatura.listaProdutoTipo,
        listaGrupoFaturamento: state.cliente.listaGrupoFaturamento,
        listaMeses: state.fatura.listaMeses,
        listaUsuarioAdministrador: state.cliente.listaUsuarioAdministrador,
        listaUsuarioAdministradorVinculado: state.cliente.listaUsuarioAdministradorVinculado,
        listaProducaoSolar: state.fatura.listaProducaoSolar,
        pdf: state.displayPDF.pdf,
        nomePdf: state.displayPDF.nomePdf,
        orientation: state.displayPDF.orientation,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            salvar,
            salvarMultiplos,
            excluir,
            getListaFaturasAdm,
            reprocessar,
            reprocessarTodas,
            buscarPdf,
            setArquivoPDF,
            executarManutencao,
            setAguardando,
            getListaGrupoFaturamento,
            buscarPdfFaturaAdicional,
            gerarRelatorio,
            gerarXlsx,
            setAlertaVerificado,
            alterarStatusAlerta,
            getListaUsuarioAdministrador,
            getListaUsuarioAdministradorVinculadoCliente,
            getListaGraficoGeracaoSaldo,
            getListaProdutoTipo,
            getListaClientesUcsFiltradosSelect,
            reprocessarIsenta,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(FaturaEnergiaAdm);
